export enum SerieStatus {
    SINGLE = 'single',
    MULTI = 'multi',
}
  